import {
  BMElevationType,
  BMPrimitives,
  BMText,
  useBMTheme,
} from "@traveloka/district-bloom";
import IcTripOneWay from "@traveloka/icon-kit-web/react/IcTripOneWay";
import IcTripRoundTrip from "@traveloka/icon-kit-web/react/IcTripRoundTrip";
import { Image, StyleSheet } from "react-native";
import BMView from "../../../../components/View/BMView";
import { useLocalizedDateFormat } from "../../../../core";
import { FlightData } from "./MobileHomeRecentSearch";

type Props = {
  data: FlightData;
};

export default function RecentSearchFlightCard(props: Props) {
  const {
    data: {
      arrivalLocation,
      departureDate,
      departureLocation,
      seatClass,
      isRoundTrip,
      arrivalImageUri,
    },
  } = props;

  const { format } = useLocalizedDateFormat();
  const { BMElevation } = useBMTheme();
  const styles = createStyles(BMElevation);

  return (
    <BMView style={styles.container} row align="center">
      <Image style={styles.image} source={{ uri: arrivalImageUri ?? "" }} />
      <BMView style={styles.content} flex spacing="xs">
        <BMView row align="center" spacing="xs">
          <BMText>{departureLocation}</BMText>
          {isRoundTrip ? (
            <IcTripRoundTrip
              width={16}
              height={16}
              color="#000"
              accentColor="#000"
            />
          ) : (
            <IcTripOneWay
              width={16}
              height={16}
              color="#000"
              accentColor="#000"
            />
          )}
          <BMText>{arrivalLocation}</BMText>
        </BMView>
        <BMText variant="uiSmallLi" ink="BMStyleTextInkSecondary">
          {format(departureDate, "SHORT_MONTH")} · {seatClass}
        </BMText>
      </BMView>
    </BMView>
  );
}

function createStyles(BMElevation: BMElevationType) {
  return StyleSheet.create({
    container: {
      paddingRight: BMPrimitives.BMSize.md,
      borderRadius: BMPrimitives.BMRadius.md,
      ...BMElevation.elevation2,
      width: 280,
      overflow: "hidden",
    },
    image: {
      width: 50,
      height: 56,
    },
    content: {
      padding: BMPrimitives.BMSize.md,
    },
  });
}
